/* AtelierNaru - Romanian labels for the wood blind configurator.
   Added 3 August 2026, when ateliernaru.ro went on the Romania market.

   Deliberately a SEPARATE file rather than a third pair inside
   assets/naru-wood-opts.js. That file is 15.5 KB and nine tenths of it is SVG
   path data for the 28 icons; re-sending all of it to add fifty short strings
   would put every one of those paths at risk of a transcription slip for no
   gain. This file only walks the option arrays and hangs a `ro` field on each
   entry, matched by key. Load it AFTER naru-wood-opts.js.

   The section reads it through T(o) and lnName(), which fall back to English
   when a `ro` field is missing - so a key added upstream and forgotten here
   degrades to English rather than to blank.

   NOT here on purpose: motor labels (the motor step owns them, in
   assets/naru-motor-step.js) and the tape WIDTH (it depends on the slat size
   and comes from tapesFor - 12 mm only holds for 25 mm slats, so no width is
   hardcoded in any label below). */
(function(){
  var U=window.NWC_UI;
  if(!U){return;}
  function set(arr,map){
    if(!arr){return;}
    arr.forEach(function(o){ if(map[o.k]){o.ro=map[o.k];} });
  }

  set(U.MOUNT,{
    glazing:['In bagheta de sticla','Prins cu suruburi in bagheta, chiar in fata geamului. Bagheta trebuie sa aiba minimum 20 mm adancime.'],
    sash:['Pe cerceveaua ferestrei','Prins cu suruburi pe cercevea, cu suporti combinati.'],
    clamp:['Pe cercevea, fara gaurire','Suporti cu clema, fara nicio gaura. Doar la ferestre PVC, cu 20 mm spatiu liber.'],
    recess:['In nisa ferestrei','Prins in tavanul nisei de fereastra.'],
    wall:['Pe perete','Pe perete sau in tavan, in fata nisei.']
  });

  set(U.OPS,{
    'ct-l':['Snur si bagheta pe stanga','Snurul de ridicare si bagheta de inclinare pe partea stanga.'],
    'ct-r':['Snur si bagheta pe dreapta','Snurul de ridicare si bagheta de inclinare pe partea dreapta.'],
    'ch-l':['Lant continuu pe stanga','Ridicare si inclinare dintr-un singur lant, pe stanga. De la 380 mm latime.'],
    'ch-r':['Lant continuu pe dreapta','Ridicare si inclinare dintr-un singur lant, pe dreapta. De la 380 mm latime.']
  });

  set(U.LAD,{
    cord:['Scarita din snur','Varianta standard, discreta.'],
    tape:['Banda textila','Banda lata, acopera gaurile din lamele.']
  });

  set(U.COV,{
    none:['Fara masca','Sina superioara ramane la vedere.'],
    straight:['Masca dreapta','Masca de lemn in culoarea lamelei, doar in fata.'],
    sides:['Masca cu laterale','Masca inchisa in fata si pe ambele laterale.'],
    left:['Masca cu laterala stanga','Masca inchisa in fata si pe stanga.'],
    right:['Masca cu laterala dreapta','Masca inchisa in fata si pe dreapta.']
  });

  set(U.GUI,{
    none:['Fara ghidaj lateral','Jaluzeaua atarna liber.'],
    cable:['Ghidaj cu cablu de otel','Cabluri pe ambele laterale - jaluzeaua nu se balanseaza cand deschizi fereastra.']
  });

  set(U.SAFE,{
    yes:['Cu siguranta pentru copii','Dispozitiv de infasurare a snurului conform EN 13120, se monteaza la cel putin 150 cm de podea.'],
    no:['Fara siguranta pentru copii','Doar pentru camere in care nu stau copii mici.']
  });

  /* Tape colours: the name is descriptive, read off the real photograph - it is
     not the supplier's official colour name. The LN code is what goes to the
     factory, in a hidden line item property. */
  var LNRO={'LN 01':'Alb','LN 04':'Coniac','LN 08':'Maro-negru','LN 24':'Gri deschis','LN 27':'Negru','LN 42':'Taupe'};
  if(U.LN){
    U.LN.forEach(function(c){
      if(LNRO[c.k]){
        c.nro=LNRO[c.k];
        c.ro=[LNRO[c.k],'Banda textila'];
      }
    });
  }
})();
